import React from "react";

import { Text } from "../../Text";
import { Wrapper } from "../../Wrapper";
import { getResizedImageURL } from "../../utils";
import classnames from "classnames";

import styles from "../styles/DefaultHero.module.scss";

export function DefaultHero({ data }: { data: any }) {
  const heroStyle = data.acf.hero_style;
  const isHeroImageShort = heroStyle === "short_image_hero";
  const isNoHeroImage = heroStyle === "no_hero";
  const heroImageURL =
    data.acf.images && data.acf.images[0] && data.acf.images[0].url;
  const heroImageURLResized =
    getResizedImageURL(heroImageURL, 2000, 1000) || "";

  return (
    <section
      className={classnames(
        styles.hero,
        isHeroImageShort ? styles.heroShort : null,
        isNoHeroImage ? styles.heroNone : null
      )}
      style={{ backgroundImage: `url(${heroImageURLResized})` }}
    >
      <Wrapper style={{ flex: "1" }}>
        <div className={styles.heroTitle}>
          <Text isCenter isHeading text={data.title.rendered} />
        </div>
      </Wrapper>
    </section>
  );
}
